import { useState, useEffect } from "react";
import {
  collection,
  doc,
  onSnapshot,
  setDoc,
  getDoc
} from "firebase/firestore";
import { db } from "../api/firebase";

interface IDelay {
  currentDelay: number;
}

export default function useDelay() {
  const [delay, setDelay] = useState<IDelay>({ currentDelay: 0 });
  const [eventId, setEventId] = useState<string | null>(null);

  useEffect(() => {
    if (!eventId) {
      return;
    }

    const delayRef = doc(db, `delay/${eventId}`);
    
    const unsubscribe = onSnapshot(delayRef, (snapshot) => {
      if (snapshot.exists()) {
        const delayData = snapshot.data() as IDelay;
        setDelay(delayData);
      } else {
        // Initialize with default value if document doesn't exist
        setDelay({ currentDelay: 0 });
      }
    });

    return () => {
      unsubscribe();
      setDelay({ currentDelay: 0 });
      setEventId(null);
    };
  }, [eventId]);

  const subscribeDelay = (id: string) => {
    if (!id) return;
    setEventId(id);
  };

  const updateDelay = async (newDelay: number) => {
    if (!eventId) return;
    
    const delayRef = doc(db, `delay/${eventId}`);
    const delayData: IDelay = { currentDelay: newDelay };
    
    await setDoc(delayRef, delayData);
  };

  return {
    subscribeDelay,
    updateDelay,
    delay
  };
}